import { modals } from './modals';

export const orderConfirmation = {
    oc: $("#order-confirmation"),
    init: () => {
        console.debug("order-confirmation.js: init");
        orderConfirmation.sendTrackingEvents();
        orderConfirmation.renderTrustpilotForm();
        //orderConfirmation.oc.on('click', '.trustpilot-rating-link', orderConfirmation.renderTrustpilotForm);
    },
    sendTrackingEvents: () => {
        let orderId = $("#order-id-data").data("value");
        let existingTransaction = sessionStorage.getItem("existing_tid");
        if (existingTransaction) {
            if (existingTransaction == orderId) { // search in array instead?
                return;
            }
            sessionStorage.existing_tid = orderId; // add to array instead?
        }
        else {
            sessionStorage.setItem("existing_tid", orderId);
        }

        orderConfirmation.pushToDataLayer(orderId);

        //if (prestashop.urls.base_url != 'https://www.dpj.se/') {
        let adsId = '';
        let conversionLabel = '';
        let userTypeVat = prestashop.configuration.display_prices_tax_incl ? 'private' : 'company';
        switch (prestashop.urls.base_url) {
            case 'https://www.dpj-workspace.com/at/':
                adsId = "AW-384198116";
                conversionLabel = "_gVNCPfCpqkYEOTLmbcB";
                break;
            case 'https://www.dpj-workspace.com/de/':
                adsId = "AW-480897207";
                conversionLabel = "V4HyCNP6l6kYELfRp-UB";
                break;
            case 'https://www.dpj-workspace.com/dk/':
                adsId = "AW-539799660";
                conversionLabel = "aT4XCPzU8qMYEOzgsoEC";
                break;
            case 'https://www.dpj-workspace.com/fi/':
                adsId = "AW-411429675";
                conversionLabel = "eFiCCLewoakYEKvWl8QB";
                break;
            case 'https://www.dpj-workspace.com/fr/':
                adsId = "AW-10859090738";
                conversionLabel = "WP6CCIi1uKYYELKmgroo";
                break;
            case 'https://www.dpj-workspace.com/nl/':
                adsId = "AW-10883698233";
                conversionLabel = "l2dPCPCa0JMYELmc4MUo";
                break;
            case 'https://www.dpj.se/':
                adsId = "AW-1001003807";
                conversionLabel = "0I4HCOa-n6kYEJ-2qN0D";
        }
        let pageViewData = {
            'send_to': adsId,
            'user_type_vat': userTypeVat,
            'value': parseFloat($("#order-product-totals-data").data("value")),
            'items': []
        }
        $(".order-product-data").each((i, el) => {
            let countrySuffix = prestashop.urls.base_url == 'https://www.dpj.se/' ? 'SE' : prestashop.urls.base_url.slice(-3).replace("/", "").toUpperCase();
            let itemId = 'DPJ' + countrySuffix + $(el).data("product-id");
            itemId = $(el).data("attribute-id") == "0" ? itemId : itemId + "v" + $(el).data("attribute-id");
            pageViewData.items.push({
                'id': itemId,
                'google_business_vertical': 'retail'
            });
        });
        const conversionData = {
            'send_to': `${adsId}/${conversionLabel}`,
            'user_type_vat': userTypeVat,
            'value': parseFloat($("#order-product-totals-data").data("value")),
            'currency': prestashop.currency.iso_code,
        };
        const userData = {
            "email": $("#order-email-data").data("value"),
            "phone_number": $("#order-phone-data").data("value"),
            'address': {
                first_name: $("#order-first-name-data").data("value"),
                last_name: $("#order-last-name-data").data("value"),
                street: $("#order-street-data").data("value"),
                city: $("#order-city-data").data("value"),
                postal_code: $("#order-postal-code-data").data("value"),
                region: '',
                country: $("#order-country-data").data("value"),
            }
        }
        try {
            gtag('set', 'user_data', userData);
            gtag('event', 'page_view', pageViewData);
            gtag('event', 'conversion', conversionData);
        } catch (error) {
            console.error("order-confirmation.js: error sending tracking events", error);
        }
        console.log(userData, pageViewData, conversionData);
        //}

        /*if (prestashop.urls.base_url == 'https://www.dpj-workspace.com/de/') {
            let data = {
                'send_to': 'AW-480897207',
                'value': parseFloat($("#order-product-totals-data").data("value")),
                'items': []
            }
            $(".order-product-data").each((i, el) => {
                let countrySuffix = prestashop.urls.base_url == 'https://www.dpj.se/' ? 'SE' : prestashop.urls.base_url.slice(-3).replace("/", "").toUpperCase();
                let itemId = 'DPJ' + countrySuffix + $(el).data("product-id");
                itemId = $(el).data("attribute-id") == "0" ? itemId : itemId + "v" + $(el).data("attribute-id");
                data.items.push({
                    'id': itemId,
                    'google_business_vertical': 'retail'
                });
            });
            gtag('event', 'page_view', data);
            gtag('event', 'conversion', {
              'send_to': 'AW-480897207/V4HyCNP6l6kYELfRp-UB',
              'value': parseFloat($("#order-product-totals-data").data("value")),
              'currency': prestashop.currency.iso_code,
              'transaction_id': orderId
            });
            console.log({
              'send_to': 'AW-480897207/V4HyCNP6l6kYELfRp-UB',
              'value': parseFloat($("#order-product-totals-data").data("value")),
              'currency': prestashop.currency.iso_code,
              'transaction_id': orderId
            });
        }
        else {
            orderConfirmation.pushToDataLayer(orderId);
        }*/
    },
    pushToDataLayer: (orderId) => {
        let data = {
            event: "purchase",
            ecommerce: {
                transaction_id: orderId,
                value: parseFloat($("#order-product-totals-data").data("value")),
                tax: parseFloat($("#order-tax-totals-data").data("value")),
                shipping: parseFloat($("#order-shipping-totals-data").data("value")),
                currency: prestashop.currency.iso_code,
                email: $("#order-email-data").data("value"),
                phone_number: $("#order-phone-data").data("value"),
                items: []
            }
        };
        $(".order-product-data").each((i, el) => {
            let item = {
                item_name: $(el).data("product-name"),
                item_brand: $(el).data("manufacturer-name"),
                item_variant: $(el).data("variant").trim().slice(0, -2),
                price: parseFloat($(el).data("price")),
                discount: parseFloat($(el).data("discount")),
                quantity: parseFloat($(el).data("quantity")),
            };
            //item.item_id = $(el).data("attribute-id") == "0" ? $(el).data("product-id") : $(el).data("product-id") + "-" + $(el).data("attribute-id");
            let countrySuffix = prestashop.urls.base_url == 'https://www.dpj.se/' ? 'SE' : prestashop.urls.base_url.slice(-3).replace("/", "").toUpperCase();
            let itemId = 'DPJ' + countrySuffix + $(el).data("product-id");
            item.item_id = $(el).data("attribute-id") == "0" ? itemId : itemId + "v" + $(el).data("attribute-id");

            if ($(el).data("categories")) {
                $(el).data("categories").forEach((category, i) => {
                    let categoryIndex = i == 0 ? "" : (i + 1);
                    item["item_category" + categoryIndex] = category.name;
                });
            }
            data.ecommerce.items.push(item);
        });
        console.log(data);
        dataLayer.push({ ecommerce: null });
        dataLayer.push(data);
    },
    renderTrustpilotForm: () => {
        if (!$("#order-conf-tp-modal").length) {
            if (typeof Trustpilot_rating_html !== 'undefined') {
                modals.ol.append(
                    '<div class="modal-box" id="order-conf-tp-modal">' +
                    '<i class="fas fa-times-circle close-modal close-modal-larger-on-modal" style="color:white;"></i>' +
                    Trustpilot_rating_html +
                    '</div>'
                );

                $("#order-conf-tp-modal").show();
                $("#order-conf-tp-modal").css("padding", "0");
                $("#order-conf-tp-modal").css("position", "relative");
                modals.togglePageOverlay();
            }
        } else {
            // Open it again
            $("#order-conf-tp-modal").show();
            modals.togglePageOverlay();
        }

        // Close modal on esc-press
        $(document).on('keyup', function (evt) {
            if (evt.keyCode == 27) {
                $(".close-modal-larger-on-modal").click();
            }
        });
    }
}
